import { useParams } from 'react-router'
import Page from '@/components/common/Page'
import { ClientAgentPage } from '@/pages/clients/ClientAgent'

export default function AgentPage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Overview"
      helpContent={{
        header: 'Agent Overview',
        body: (
          <div>
            <p>Monitor your autonomous marketing agent's current status, pending decisions, and recent actions.</p>
            <h4>Sections:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li><strong>Agent Status</strong> - Current goal, persona, and next scheduled run</li>
              <li><strong>Exception Queue</strong> - Items requiring your manual review</li>
              <li><strong>Recent Decisions</strong> - History of agent decisions and actions</li>
            </ul>
            <h4>What to Do:</h4>
            <p>Review exceptions and approve or reject items. Use the Chat page to communicate with the agent.</p>
          </div>
        ),
      }}
    >
      <ClientAgentPage clientId={clientId} />
    </Page>
  )
}
